import PropTypes from "prop-types";
import dayjs from "@shared/dayjs";
import changeVisibilityShape from "./changeVisibility";

const feedbackShape = PropTypes.shape({
  id: PropTypes.number,
  liked: PropTypes.number,
  body: PropTypes.string,
  externallyVisible: PropTypes.bool,
  shownBy: PropTypes.string,
  showingType: PropTypes.string,
  shownAt: PropTypes.instanceOf(dayjs),
  meta: PropTypes.shape({
    changeVisibility: changeVisibilityShape,
  }),
});

export default feedbackShape;
